/**
 * Redux middleware for API token injection
 * 
 * Note: This middleware doesn't actually modify actions.
 * It's here for future extensibility. Token injection happens
 * via the token getter function passed to the API client.
 */

import { createLogger } from '../../config/logger';
import { selectAccessToken } from '../selectors';

const logger = createLogger('apiMiddleware');

/**
 * Creates a token getter function for axios interceptor
 * @param {Function} getState - Redux getState function
 * @returns {Function} Token getter that returns the current access token
 */
export const createTokenGetter = (getState) => {
    return () => {
        try {
            const state = getState();
            return selectAccessToken(state);
        } catch (err) {
            logger.error('Error getting access token from state', err);
            return null;
        }
    };
};

